import { useMemo } from "react";
import { makeQueryString } from "core/makeQueryString";
import { useFetchGet } from "hooks/fetch/useFetchGet";

export function useGetRules(page = 1, pageSize = 10) {
  const url = useMemo(
    () => `read_rules` + makeQueryString({ page, size: pageSize }),
    [page, pageSize]
  );
  const { loading, error, response, refetch } = useFetchGet(url);

  return {
    loading,
    error,
    rules: response?.results ?? [],
    count: response?.count ?? 0,
    refetchRules: refetch
  };
}
